// cspell:words octocat lazer duckhunt

import './assets/font/lazer84.css';
import './assets/font/duckhunt.css';
import './style.css';
import zapperImgUrl from './assets/img/zapper.svg';
import octocatImgUrl from './assets/img/octocat.svg';
import gridImgUrl from './assets/img/grid.svg';

const zapperImgEl = document.querySelector('.zapper-icon') as HTMLElement;
const octocatImgEl = document.querySelector('.octocat-icon') as HTMLElement;
const gridImgEl = document.querySelector('.grid-icon') as HTMLElement;

let replayElement = document.querySelector('.replay-text') as HTMLElement;

/**
 * Show replay when complete
 */
function replay() {
  if (replayElement) {
    replayElement.style.display = 'block';
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    replayElement.addEventListener('click', startGame);
  }
}

/**
 * Start Game
 */
function startGame() {
  document.body.className = 'duckhunt';
  replayElement = document.querySelector('.replay-text') as HTMLElement;
  replayElement.style.display = 'none';
  globalThis.duckhunt(replay);
}

if (octocatImgEl) {
  octocatImgEl.style.backgroundImage = `url("${octocatImgUrl}")`;
}

if (zapperImgEl) {
  zapperImgEl.style.backgroundImage = `url("${zapperImgUrl}")`;
  zapperImgEl.addEventListener('click', startGame);
}

if (gridImgEl) {
  gridImgEl.style.backgroundImage = `url("${gridImgUrl}")`;
  gridImgEl.addEventListener('click', () => {
    document.body.classList = '';
    replayElement = document.querySelector('.replay-text') as HTMLElement;
    replayElement.style.display = 'none';
  });
}
